import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import Play from '../ControlBar/Play/Play';
import Close from './Close/Close';
import ProgressBarContainer from '../ControlBar/ProgressBar/ProgressBarContainer';
import {
  Content,
  MiniControlContainer,
  TopBar,
  ProgressBar,
} from './styles';

import RestoreMiniPlayer from './RestorePlayer/RestoreMiniPlayer';
import Rewind from '../ControlBar/Seek/Rewind';
import FastForward from '../ControlBar/Seek/FastForward';

const MiniControl = React.forwardRef(({ isPauseOverlayVisible, onHoverStateChange }, ref) => {
  const {
    isPlayingAds,
    playing,
    controlsVisible,
    isPlayingDaiAds,
    rights,
  } = useSelector(({ playback, controls }) => ({
    chromecastState: playback.chromecastState,
    chromecastEnabled: playback.chromecastEnabled,
    isPlayingAds: playback.isPlayingAds,
    isPlayingDaiAds: playback.isPlayingDaiAds,
    rights: playback.rights,
    playing: playback.playing,
    metadata: playback.metadata,
    viewableMetadata: playback.viewableMetadata,
    deviceName: playback.chromecastFriendlyName,
    controlsVisible: controls.controlsVisible,
  }), shallowEqual);

  const onMouseEnter = () => onHoverStateChange(true);
  const onMouseLeave = () => onHoverStateChange(false);

  const controlBarVisible = playing ? controlsVisible : !isPauseOverlayVisible; // hide controlbar if pause overlay is visible

  const isRewindVisible = !isPlayingAds && (!isPlayingDaiAds || rights.adsRewind);
  const isFastForwardVisible = !isPlayingAds && (!isPlayingDaiAds || rights.adsFastForward);
  const isPlayVisible = !isPlayingDaiAds || rights.adsPause || !playing;

  return (
    <MiniControlContainer
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {controlBarVisible && (
      <>
        <TopBar>
          <RestoreMiniPlayer />
          <Close />
        </TopBar>

        <Content>
          {isRewindVisible && <Rewind isMini />}
          {isPlayVisible && <Play isLarge isMini />}
          {isFastForwardVisible && <FastForward isMini />}
        </Content>
      </>
      )}

      {controlBarVisible && !isPlayingAds && (
      <ProgressBar>
        <ProgressBarContainer mini />
      </ProgressBar>
      )}
    </MiniControlContainer>
  );
});

MiniControl.propTypes = {
  isPauseOverlayVisible: PropTypes.bool.isRequired,
  onHoverStateChange: PropTypes.func.isRequired,
};

export default React.memo(MiniControl);
